import './layout.css';
import { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { Link } from 'react-router-dom';


export default function Layout({ children, links }) {
    const [toggled, setToggled] = useState(false);

return <div className="layout">
        <header>
            <div className='banner'>
                <img
                    src="/v1/api/assets/1/$blob"
                    alt="Logo"
                    style={{ padding: '0 0 0 1rem' }}
                />
            </div>
            <nav onClick={() => {isMobile && setToggled(!toggled)}} className={toggled ? 'toggled' : ''}>
                {links.map((link) => 
                    (!link.fn)
                        ? <Link to={link.href}>{link.text}</Link>
                        : <Link to={`#${link.text}`} onClick={link.fn}>{link.text}</Link>
                )}
            </nav>
        </header>
        <main>
            {children}
        </main>
    </div>
}
